import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";

export default defineComponent({
  name: "statusIndicator",
  props: {
    itemStatus: {
      type: String,
      required: true,
    },
  },

  setup(props, _ctx) {
    const statusIcon = computed(() => {
      if (props.itemStatus === "pending") {
        return "spinner";
      } else if (props.itemStatus === "queued") {
        return ["far", "circle"];
      } else if (props.itemStatus === "archived") {
        return "archive";
      } else {
        return "check-circle";
      }
    });

    return {
      statusIcon,
    };
  },
});
